import React from 'react';

import Navbar from '../../components/Navbar';
import Header from './Header';
import { Container } from './styles';

function Instructions() {
  return (
    <Container>
      <Navbar />
      <Header />
    </Container>
  );
}

export default Instructions;
